import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {RequestParameters} from '../shared/models/request-parameters/parameter.model';
import {GlobalVariable} from '../global';
import {CallCenter} from './call-center.model';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class CallCenterService {
  private subject = new Subject<any>();
  constructor(private http: HttpClient) {
  }

  getCallCenters (parameters: RequestParameters = new RequestParameters()) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/call-centers', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  getCallCenter (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/call-center/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  postCallCenter (callCenter: CallCenter) {

    const body = this.normalizeCallCenterData(callCenter);

    return this.http.post(GlobalVariable.BASE_API_URL + '/call-centers', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putCallCenter (callCenter: CallCenter) {

    const body = this.normalizeCallCenterData(callCenter);

    return this.http.put(GlobalVariable.BASE_API_URL + '/call-center/' + callCenter.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  deleteCallCenter (callCenter: CallCenter) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/call-center/' + callCenter.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }
  disableCallCenter(callCenter: CallCenter, stateToApply) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/call-center/' + callCenter.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }
  private normalizeCallCenterData(callCenter: CallCenter): CallCenter {
    const body = Object.assign({}, callCenter);
    delete body.reference;
    if (body.country !== null) {
      body.country = body.country.reference;
    }
    if (body.manager !== null) {
      body.manager = body.manager.reference;
    }

    return body;
  }
  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/call-center/call-center.service.ts